// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"a0b997fb","editFormSmallButton":"e71af35a"};